import { cloneDeep } from 'lodash'
import { StateCreator } from 'zustand'

import EHeyLibbyAdminNavItemNames from '~/layouts/account/constants/navItems'

type TUIElements = {
  UIElements: TUIElementsDefinition
}
type TUIElementsDefinition = {
  sideNavOpenSections: Record<string, boolean>
  isSideNavPinned: boolean
  isGuidanceOpen: boolean
  isAgentInfoHeaderOpen: boolean
}
export type TUIElementsState = TUIElements & {
  setUIElements(UIElements: Partial<TUIElementsDefinition>): void
  resetUIElements(): void
}

export const initialUIElementsState: TUIElementsDefinition = {
  sideNavOpenSections: {
    [EHeyLibbyAdminNavItemNames.siteMetadata]: true,
  },
  isSideNavPinned: true,
  isAgentInfoHeaderOpen: true,
  isGuidanceOpen: false,
}

const createUIElementsSlice: StateCreator<
  TUIElementsState,
  [['zustand/devtools', unknown]],
  []
> = (set) => ({
  UIElements: cloneDeep(initialUIElementsState),
  setUIElements: (UIElements) =>
    set(
      (state) => ({ UIElements: { ...state.UIElements, ...UIElements } }),
      undefined,
      {
        type: 'UIElements',
        UIElements,
      },
    ),
  resetUIElements: () =>
    set(() => ({ UIElements: cloneDeep(initialUIElementsState) }), undefined, {
      type: 'resetUIElements',
    }),
})

export default createUIElementsSlice
